import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { StudioService } from '../../core/services/studio.service';
import { StudioSelectionService } from '../../core/services/studio-selection.service';
import { PagerComponent } from '../../shared/components/pager.component';

const SESSION_KEY = 'insurance_select_studio_id';

function buildYearList(startYear: number, endYear: number): { id: number; name: string }[] {
  const list = [];
  for (let y = startYear; y <= endYear; y++) list.push({ id: y, name: `${y}年` });
  return list;
}

function buildMonthList(): { id: string; name: string }[] {
  const list = [];
  for (let m = 1; m <= 12; m++) list.push({ id: String(m).padStart(2, '0'), name: `${m}月` });
  return list;
}

function downloadCsv(rows: string[][], headers: string[], filename: string): void {
  const escape = (v: string) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  const lines = [headers.map(escape).join(','), ...rows.map(r => r.map(escape).join(','))];
  const bom = '﻿';
  const blob = new Blob([bom + lines.join('\r\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

@Component({
    selector: 'app-insurance-list',
    imports: [FormsModule, DatePipe, PagerComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
        </div>
        <div class="card-body">
          <div style="height: 1px"></div>
          <form novalidate name="myForm">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="studio_name">店舗</label>
                    <select class="form-control" id="studio_name" name="studio_name"
                      [(ngModel)]="selectedStudio" (ngModelChange)="onStudioChange()">
                      <option [ngValue]="null">-- {{ optionString }} --</option>
                      @for (studio of studios; track studio.id) {
                        <option [ngValue]="studio">{{ studio.name }}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row or-conditions-box">
              <span class="box-title">入退会月（OR条件）</span>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="col-form-label custom-control custom-checkbox" for="use_start_date">
                    <input class="custom-control-input" [(ngModel)]="useStartDate" (ngModelChange)="pageIndex = 0" id="use_start_date" name="use_start_date" type="checkbox">
                    <label class="custom-control-label" for="use_start_date">入会月</label>
                  </label>
                  <div class="bisected-input-wrap">
                    <div class="bisected-input">
                      <select class="form-control" id="start_date_year" name="start_date_year"
                        [(ngModel)]="startDateYear" (ngModelChange)="pageIndex = 0" [disabled]="!useStartDate">
                        <option [ngValue]="null">-- すべて --</option>
                        @for (ypo of yearPayOption; track ypo.id) {
                          <option [ngValue]="ypo">{{ ypo.name }}</option>
                        }
                      </select>
                    </div>
                    <div><span>&nbsp;</span></div>
                    <div class="bisected-input">
                      <select class="form-control" id="start_date_month" name="start_date_month"
                        [(ngModel)]="startDateMonth" (ngModelChange)="pageIndex = 0" [disabled]="!useStartDate">
                        <option [ngValue]="null">-- すべて --</option>
                        @for (mpo of monthPayOption; track mpo.id) {
                          <option [ngValue]="mpo">{{ mpo.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="col-form-label custom-control custom-checkbox" for="use_end_date">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="useEndDate" (ngModelChange)="pageIndex = 0" id="use_end_date" name="use_end_date">
                    <label class="custom-control-label" for="use_end_date">退会月</label>
                  </label>
                  <div class="bisected-input-wrap">
                    <div class="bisected-input">
                      <select class="form-control" id="end_date_year" name="end_date_year"
                        [(ngModel)]="endDateYear" (ngModelChange)="pageIndex = 0" [disabled]="!useEndDate">
                        <option [ngValue]="null">-- すべて --</option>
                        @for (ypo of yearPayOption; track ypo.id) {
                          <option [ngValue]="ypo">{{ ypo.name }}</option>
                        }
                      </select>
                    </div>
                    <div><span>&nbsp;</span></div>
                    <div class="bisected-input">
                      <select class="form-control" id="end_date_month" name="end_date_month"
                        [(ngModel)]="endDateMonth" (ngModelChange)="pageIndex = 0" [disabled]="!useEndDate">
                        <option [ngValue]="null">-- すべて --</option>
                        @for (mpo of monthPayOption; track mpo.id) {
                          <option [ngValue]="mpo">{{ mpo.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            @if (showFilterOption) {
              <div class="row" style="align-items: flex-end;">
                <div class="col-md-8">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label" for="keyword">キーワード検索</label>
                      <input id="keyword" name="keyword" type="text" [(ngModel)]="keyword"
                        class="form-control" placeholder="会員ID、会員氏名、申請種別など"
                        (ngModelChange)="pageIndex = 0">
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                        <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </form>
          <hr>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              @if (userPermission <= 10 || selectedStudio) {
                <button class="form-group btn btn-success" type="button" (click)="openDownloadModal()">
                  <div class="file_format_icon dl">
                    <div>
                      <span title="csv"></span>
                      <span class="material-icons-outlined">download</span>
                    </div>
                  </div>
                  &nbsp;処理予定者ダウンロード
                </button>
              }
              @if (showFilterOption) {
                <button class="form-group btn btn-success" type="button" (click)="downloadCurrent()" [disabled]="disableDownload">
                  <div class="file_format_icon dl">
                    <div>
                      <span title="csv"></span>
                      <span class="material-icons-outlined">download</span>
                    </div>
                  </div>
                  &nbsp;ダウンロード
                </button>
              }
              <button id="csv_download" class="d-none" type="button" aria-hidden="true" tabindex="-1"></button>
            </div>
          </div>
          <form name="notificationDataForm" method="POST" action="/" style="display: none;">
            <input type="text" name="dataForExcel0">
            <input type="text" name="selectMonth">
            <input type="text" name="selectStudioName">
          </form>
          <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
          @if (selectedStudio && !searching && filteredItems.length === 0) {
            <span>該当するデータはありません</span>
          }
          @if (filteredItems.length > 0) {
            <table class="table table-bordered table-sm table-hover table-ptb-0">
              <thead>
                <tr>
                  <th width="10%">店舗名</th>
                  <th width="10%">会員ID</th>
                  <th>会員氏名(かな)</th>
                  <th width="15%">開始月</th>
                  <th width="15%">終了月</th>
                </tr>
              </thead>
              <tbody>
                @for (item of pagedItems; track item.id) {
                  <tr>
                    <td>{{ item.notificationRequest?.member?.studio?.name }}</td>
                    <td>{{ item.notificationRequest?.member?.memberCode }}</td>
                    <td>
                      <a href="" (click)="$event.preventDefault(); setSelectMember(item.notificationRequest?.member)">
                        {{ item.notificationRequest?.member?.lastName }}&nbsp;{{ item.notificationRequest?.member?.firstName }}&#040;{{ item.notificationRequest?.member?.lastNameKana }}&nbsp;{{ item.notificationRequest?.member?.firstNameKana }}&#041;
                      </a>
                    </td>
                    <td>{{ item.notificationRequest?.startDate | date:'yyyy年MM月' }}</td>
                    <td>{{ item.notificationRequest?.endDate | date:'yyyy年MM月末' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
          <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 会員詳細モーダル -->
@if (showMemberModal) {
  <div class="modal-backdrop fade show" (click)="showMemberModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="getMemberDetailModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="getMemberDetailModalLabel">会員情報 / 詳細</h5>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <table class="table table-sm table-borderless">
              <tr>
                <th class="text-right" style="width: 40%;">会員ID：</th>
                <td>{{ selectedMember?.memberCode }}</td>
              </tr>
              <tr>
                <th class="text-right">会員氏名（かな）：</th>
                <td>{{ selectedMember?.lastName }} {{ selectedMember?.firstName }}({{ selectedMember?.lastNameKana }} {{ selectedMember?.firstNameKana }})</td>
              </tr>
              <tr>
                <th class="text-right">生年月日：</th>
                <td>{{ selectedMember?.birthday }}</td>
              </tr>
              <tr>
                <th class="text-right">住所：</th>
                <td>〒{{ selectedMember?.zip }}</td>
              </tr>
              <tr>
                <th class="text-right"></th>
                <td>{{ selectedMember?.province }}&nbsp;{{ selectedMember?.city }}</td>
              </tr>
              <tr>
                <th class="text-right"></th>
                <td>{{ selectedMember?.area }}&nbsp;{{ selectedMember?.address }}</td>
              </tr>
              <tr>
                <th class="text-right">電話番号：</th>
                <td>{{ selectedMember?.phone }}</td>
              </tr>
              <tr>
                <th class="text-right">メールアドレス：</th>
                <td>{{ selectedMember?.email }}</td>
              </tr>
              <tr>
                <th class="text-right">コース区分：</th>
                <td>{{ selectedMember?.studioPlan?.name }}</td>
              </tr>
              <tr>
                <th class="text-right">支払方法：</th>
                <td>
                  @if (selectedMember?.payment?.paymentMethod === 0) { <span>口座振替</span> }
                  @if (selectedMember?.payment?.paymentMethod === 1) { <span>クレジット</span> }
                </td>
              </tr>
              <tr>
                <th class="text-right">入退館キー：</th>
                <td>{{ selectedMember?.keyNumber?.keyNumber }}</td>
              </tr>
              <tr>
                <th class="text-right">ロッカー：</th>
                <td>{{ selectedMember?.lockerNumber?.lockerNumber }}</td>
              </tr>
              <tr>
                <th class="text-right">登録日時：</th>
                <td>{{ selectedMember?.createdAt | date:'yyyy/MM/dd HH:mm' }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showMemberModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- 処理予定者ダウンロード確認モーダル -->
@if (showDownloadModal) {
  <div class="modal-backdrop fade show" (click)="showDownloadModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="downloadModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="downloadModalLabel">当月末処理予定者ダウンロード</h5>
          <button type="button" class="close" (click)="showDownloadModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          当月末処理予定の保険適応対象者をダウンロードします。<br /><br />
          対象店舗: {{ selectedStudio?.name || 'すべて' }}<br />
          適応月: {{ startDateForModal }}適応開始もしくは、{{ endDateForModal }}適応終了<br /><br />
          ダウンロードしますか？
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showDownloadModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-success" type="button" (click)="downloadFuture()" [disabled]="disableDownload">
            <i class="fa s-icon-dawnload"></i>&nbsp;はい
          </button>
        </div>
      </div>
    </div>
  </div>
}
  `
})
export class InsuranceListComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private authState = inject(AuthStateService);
  private studioService = inject(StudioService);
  private studioSelection = inject(StudioSelectionService);

  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }
  get optionString(): string { return this.userPermission <= 10 ? 'すべて' : '選択してください'; }

  studios: any[] = [];
  selectedStudio: any = null;
  items: any[] = [];
  keyword = '';
  private loadRevision = 0;
  searching = false;
  showFilterOption = false;

  // Date filters
  readonly yearPayOption = buildYearList(2015, new JstDate().getFullYear() + 1);
  readonly monthPayOption = buildMonthList();
  useStartDate = true;
  startDateYear: any = null;
  startDateMonth: any = null;
  useEndDate = false;
  endDateYear: any = null;
  endDateMonth: any = null;

  // Pagination
  readonly pageLimit = 300;
  pageIndex = 0;

  // Member detail modal
  showMemberModal = false;
  selectedMember: any = null;

  // Download modal
  showDownloadModal = false;
  disableDownload = false;
  startDateForModal = '';
  endDateForModal = '';

  get filteredItems(): any[] {
    let list = this.items;

    list = list.filter(item => matchesNestedKeyword(item, this.keyword));

    if (this.useStartDate || this.useEndDate) {
      list = list.filter(i => {
        let isStartDateInRange = true;
        let isEndDateInRange = true;

        if (this.useStartDate) {
          const sd = i.notificationRequest?.startDate;
          if (!sd) {
            isStartDateInRange = !this.startDateYear && !this.startDateMonth;
          } else {
            const d = new JstDate(sd);
            if (this.startDateYear) isStartDateInRange = d.getFullYear() === this.startDateYear.id;
            if (isStartDateInRange && this.startDateMonth) isStartDateInRange = d.getMonth() + 1 === Number(this.startDateMonth.id);
          }
        }

        if (this.useEndDate) {
          const ed = i.notificationRequest?.endDate;
          if (!ed) {
            isEndDateInRange = !this.endDateYear && !this.endDateMonth;
          } else {
            const d = new JstDate(ed);
            if (this.endDateYear) isEndDateInRange = d.getFullYear() === this.endDateYear.id;
            if (isEndDateInRange && this.endDateMonth) isEndDateInRange = d.getMonth() + 1 === Number(this.endDateMonth.id);
          }
        }

        return (this.useStartDate && this.useEndDate)
          ? isStartDateInRange || isEndDateInRange
          : isStartDateInRange && isEndDateInRange;
      });
    }

    return list;
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }

  get totalPages(): number { return Math.ceil(this.filteredItems.length / this.pageLimit); }

  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員管理', 's-icon-members');
    this.studios = await this.studioService.list('all') ?? [];

    const restored = this.studioSelection.restore(this.studios, SESSION_KEY);
    if (restored) {
      this.selectedStudio = restored;
      await this.loadInsurance();
    } else if (this.userPermission <= 10) {
      await this.loadInsurance();
    }
  }

  async onStudioChange(): Promise<void> {
    ++this.loadRevision;
    this.items = [];
    this.searching = false;
    this.showFilterOption = false;
    if (!this.selectedStudio) {
      this.studioSelection.clear(SESSION_KEY);
      if (this.userPermission <= 10) await this.loadInsurance();
      return;
    }
    this.studioSelection.save(this.selectedStudio, SESSION_KEY);
    await this.loadInsurance();
  }

  private async loadInsurance(): Promise<void> {
    const revision = ++this.loadRevision;
    const studioId = this.selectedStudio?.id ?? 'all';
    if (this.userPermission > 10 && studioId === 'all') return;
    this.searching = true;
    try {
      const data = await this.studioService.getInsuranceLog(studioId, '9') ?? [];
      if (revision !== this.loadRevision) return;
      this.items = data;
      this.showFilterOption = data.length > 0;
      this.pageIndex = 0;
    } finally {
      if (revision === this.loadRevision) this.searching = false;
    }
  }

  async clearFilter(): Promise<void> {
    this.keyword = '';
    this.useStartDate = false;
    this.startDateYear = null;
    this.startDateMonth = null;
    this.useEndDate = false;
    this.endDateYear = null;
    this.endDateMonth = null;
    this.pageIndex = 0;
    this.selectedStudio = null;
    await this.onStudioChange();
  }

  setSelectMember(member: any): void {
    this.selectedMember = member;
    this.showMemberModal = true;
  }

  openDownloadModal(): void {
    const now = new JstDate();
    this.startDateForModal = `${now.getFullYear()}年${now.getMonth() + 2}月`;
    this.endDateForModal = `${now.getFullYear()}年${now.getMonth() + 1}月末`;
    this.showDownloadModal = true;
  }

  async downloadFuture(): Promise<void> {
    this.disableDownload = true;
    try {
      const studioId = this.selectedStudio?.id ?? 'all';
      const now = new JstDate();
      const targetMonth = `${now.getFullYear()}-${String(now.getMonth() + 2).padStart(2, '0')}`;
      const data = await this.studioService.getInsurance(studioId, targetMonth) ?? [];
      this.triggerCsvDownload(data);
      this.showDownloadModal = false;
    } finally {
      this.disableDownload = false;
    }
  }

  downloadCurrent(): void {
    this.disableDownload = true;
    this.triggerCsvDownload(this.filteredItems);
    setTimeout(() => { this.disableDownload = false; }, 500);
  }

  private triggerCsvDownload(data: any[]): void {
    const headers = [
      'ステータス（入会1：退会2：変更3）',
      '会員ID（ハイフンなし）',
      '名前',
      'フリガナ',
      '性別（男性1：女性2）',
      '生年月日（YYYYMMDDの形式で8桁）',
      '店舗名（資料では拠点名です）',
      '郵便番号',
      '住所',
      '電話番号',
      'Email',
      '開始月',
      '終了月',
    ];
    const rows = data.map(d => [
      d.csvStatus ?? '',
      d.csvMemberCode ?? '',
      d.csvName ?? '',
      d.csvNameKana ?? '',
      d.csvGender ?? '',
      d.csvBirthday ?? '',
      d.csvStudioName ?? '',
      d.csvZip ?? '',
      `${d.csvAddress1 ?? ''}${d.csvAddress2 ?? ''}`,
      d.csvPhone ?? '',
      d.csvEmail ?? '',
      d.csvStartDate ?? '',
      d.csvEndDate ?? '',
    ]);
    downloadCsv(rows, headers, `${Date.now()}.csv`);
  }
}
